import type { ApprovalStage } from "./contracts.js";

export const approvalStagePaths: Record<ApprovalStage, string> = {
  SHIFT_SUPERVISOR: "/vardiya-amiri-onay",
  PRODUCTION_ENGINEER: "/uretim-sefi-onay",
  PRODUCTION_MANAGER: "/uretim-muduru-onay",
};

export function approvalStageForPath(pathname: string): ApprovalStage | null {
  if (pathname === "/uretim-muhendisi-onay") return "PRODUCTION_ENGINEER";
  for (const stage of Object.keys(approvalStagePaths) as ApprovalStage[]) {
    if (approvalStagePaths[stage] === pathname) return stage;
  }
  return null;
}

export function approvalFormPath(stage: ApprovalStage, formId?: string): string {
  const path = approvalStagePaths[stage];
  return formId ? `${path}?form=${encodeURIComponent(formId)}` : path;
}

export function canonicalApprovalLocation(pathname: string, search = "", hash = ""): string | null {
  const stage = approvalStageForPath(pathname);
  if (!stage || pathname === approvalStagePaths[stage]) return null;
  return `${approvalStagePaths[stage]}${search}${hash}`;
}
